module.exports = __webpack_public_path__ + "img/0.d6642b8d.jpg";